(function () {
  // Theme manager for:
  // - user preference persistence in localStorage
  // - toggle accessibility state updates
  // - brand logo source swapping by active theme
  var STORAGE_KEY = 'mozaic-theme';
  var root = document.documentElement;
  var toggle = document.querySelector('[data-theme-toggle]');
  var brandLogo = document.getElementById('brand-logo');
  var media = window.matchMedia('(prefers-color-scheme: dark)');

  // Returns saved user preference, or null when unavailable/invalid.
  function readStoredTheme() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (error) {
      return null;
    }
  }

  // Persists explicit user choice so it overrides OS preference.
  function writeStoredTheme(theme) {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // Ignore storage errors in restricted browsing contexts.
    }
  }

  // Effective theme = explicit root data-theme, otherwise OS preference.
  function getEffectiveTheme() {
    if (root.dataset.theme === 'light' || root.dataset.theme === 'dark') {
      return root.dataset.theme;
    }

    return media.matches ? 'dark' : 'light';
  }

  // Keeps aria labels and pressed state in sync with current theme.
  function updateToggleUI() {
    if (!toggle) {
      return;
    }

    var isDark = getEffectiveTheme() === 'dark';
    toggle.setAttribute('aria-pressed', String(isDark));
    toggle.setAttribute('aria-label', isDark ? 'Activate light mode' : 'Activate dark mode');
  }

  // Uses separate logo assets for light and dark backgrounds.
  function updateBrandLogo() {
    if (!brandLogo) {
      return;
    }

    var lightLogo = new URL('../../assets/logo-text-transparent.png', import.meta.url).toString();
    var darkLogo = new URL('../../assets/logo-text-light-transparent.png', import.meta.url).toString();
    var theme = getEffectiveTheme();
    var nextSrc = theme === 'dark' ? darkLogo || lightLogo : lightLogo || darkLogo;

    if (nextSrc) {
      brandLogo.src = nextSrc;
    }
  }

  // Apply stored preference at startup before first interaction.
  var storedTheme = readStoredTheme();
  if (storedTheme) {
    root.dataset.theme = storedTheme;
  }

  updateToggleUI();
  updateBrandLogo();

  if (!toggle) {
    return;
  }

  // User-triggered theme toggle.
  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    var nextTheme = getEffectiveTheme() === 'dark' ? 'light' : 'dark';
    root.dataset.theme = nextTheme;
    writeStoredTheme(nextTheme);
    updateToggleUI();
    updateBrandLogo();
  });

  // Respond to OS theme changes only when user has no explicit saved preference.
  function handleSystemThemeChange() {
    // If user has a stored preference, do not override it on OS changes.
    if (readStoredTheme()) {
      return;
    }

    updateToggleUI();
    updateBrandLogo();
  }

  // Browser compatibility for media query change listeners.
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', handleSystemThemeChange);
  } else if (typeof media.addListener === 'function') {
    media.addListener(handleSystemThemeChange);
  }
})();
